import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";
import { debounce } from "lodash";

const ViewAccessRequestPopup = ({ onClose, isView }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const location = useLocation();

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [popupData, setPopupData] = useState([]);
  const [popupDataTable, setPopupDataTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stockData, setStockData] = useState([
    {
      code: "AQLT",
      stock_name: "Betashares Australian Quality ETF",
      quantity: 2250,
    },
    {
      code: "IHVV",
      stock_name: "iShares S&P 500 AUD Hedged ETF",
      quantity: 197,
    },
  ]);
  const [strategyData, setStrategyData] = useState([
    {
      name: "Growth",
      id: 1,
      products: [
        {
          name: "Australian Equity",
          color_code: "4472C4",
          id: 1,
          stocks: [
            {
              stock_id: 17,
              stock_name: "iShares Edge MSCI Australia Minimum Volatility ETF",
              asx_code: "MVOL",
              quantity: 728,
              current_price: 34.61,
              current_value: 25196.08,
              current_percentage: 3.35,
              target_percentage: 3.25,
              product_id: 1,
              product_name: "Australian Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "4472C4",
              target_value: 24421.36,
              difference_value: 774.72,
              difference_percentage: 0.1,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 18,
              stock_name: "VanEck Vectors Small Companies Masters ETF",
              asx_code: "MVS",
              quantity: 822,
              current_price: 19.79,
              current_value: 16267.38,
              current_percentage: 2.16,
              target_percentage: 2,
              product_id: 1,
              product_name: "Australian Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "4472C4",
              target_value: 15028.53,
              difference_value: 1238.85,
              difference_percentage: 0.16,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 13,
              stock_name: "iShares Core S&P/ASX 200 ETF",
              asx_code: "IOZ",
              quantity: 745,
              current_price: 29.59,
              current_value: 22044.55,
              current_percentage: 2.93,
              target_percentage: 3.5,
              product_id: 1,
              product_name: "Australian Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "4472C4",
              target_value: 26299.93,
              difference_value: -4255.38,
              difference_percentage: -0.57,
              action: "buy",
              action_value: 4255.38,
              action_quantity: 143,
            },
          ],
          current_value: 63508.01,
          target_value: 65749.82,
          difference_value: -2241.81,
          current_percentage: 8.45,
          target_percentage: 8.75,
          difference_percentage: -0.3,
          action: "none",
          action_value: 0,
        },
        {
          name: "Australian Property",
          color_code: "A5A5A5",
          id: 3,
          stocks: [
            {
              stock_id: 26,
              stock_name: "Vanguard Australian Property Securities Index ETF",
              asx_code: "VAP",
              quantity: 298,
              current_price: 84.36,
              current_value: 25139.28,
              current_percentage: 3.35,
              target_percentage: 2,
              product_id: 3,
              product_name: "Australian Property",
              category_id: 1,
              category_name: "Growth",
              color_code: "A5A5A5",
              target_value: 15028.53,
              difference_value: 10110.75,
              difference_percentage: 1.35,
              action: "sell",
              action_value: 10110.75,
              action_quantity: 119,
            },
          ],
          current_value: 25139.28,
          target_value: 15028.53,
          difference_value: 10110.75,
          current_percentage: 3.35,
          target_percentage: 2,
          difference_percentage: 1.35,
          action: "sell",
          action_value: 10110.75,
        },
        {
          name: "Global Equity",
          color_code: "ED7D31",
          id: 2,
          stocks: [
            {
              stock_id: 12,
              stock_name: "iShares Global 100 ETF",
              asx_code: "IOO",
              quantity: 154,
              current_price: 158.3,
              current_value: 24378.2,
              current_percentage: 3.24,
              target_percentage: 3,
              product_id: 2,
              product_name: "Global Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "ED7D31",
              target_value: 22542.8,
              difference_value: 1835.4,
              difference_percentage: 0.24,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 123,
              stock_name: "iShares S&P 500 AUD Hedged ETF",
              asx_code: "IHVV",
              quantity: 235,
              current_price: 44.66,
              current_value: 10495.1,
              current_percentage: 1.4,
              target_percentage: 1.75,
              product_id: 2,
              product_name: "Global Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "ED7D31",
              target_value: 13149.96,
              difference_value: -2654.86,
              difference_percentage: -0.35,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 28,
              stock_name: "Vanguard FTSE Emerging Markets Shares ETF",
              asx_code: "VGE",
              quantity: 194,
              current_price: 77.68,
              current_value: 15069.92,
              current_percentage: 2.01,
              target_percentage: 1.75,
              product_id: 2,
              product_name: "Global Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "ED7D31",
              target_value: 13149.96,
              difference_value: 1919.96,
              difference_percentage: 0.26,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 23,
              stock_name: "VanEck MSCI International Quality ETF",
              asx_code: "QUAL",
              quantity: 340,
              current_price: 51.85,
              current_value: 17629,
              current_percentage: 2.35,
              target_percentage: 2.75,
              product_id: 2,
              product_name: "Global Equity",
              category_id: 1,
              category_name: "Growth",
              color_code: "ED7D31",
              target_value: 20664.23,
              difference_value: -3035.23,
              difference_percentage: -0.4,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
          ],
          current_value: 67572.22,
          target_value: 69506.95,
          difference_value: -1934.73,
          current_percentage: 8.99,
          target_percentage: 9.25,
          difference_percentage: -0.26,
          action: "none",
          action_value: 0,
        },
      ],
      current_value: 156219.51,
      target_value: 150285.3,
      difference_value: 5934.21,
      current_percentage: 20.79,
      target_percentage: 20,
      difference_percentage: 0.79,
      action: "sell",
      action_value: 5934.21,
    },
    {
      name: "Defensive",
      id: 2,
      products: [
        {
          name: "Australian Bonds",
          color_code: "70AD47",
          id: 6,
          stocks: [
            {
              stock_id: 24,
              stock_name: "VanEck Australian Subordinated Debt ETF",
              asx_code: "SUBD",
              quantity: 1978,
              current_price: 24.97,
              current_value: 49390.66,
              current_percentage: 6.57,
              target_percentage: 7,
              product_id: 6,
              product_name: "Australian Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "70AD47",
              target_value: 52599.86,
              difference_value: -3209.2,
              difference_percentage: -0.43,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 4,
              stock_name: "VanEck Vectors Australian Floating Rate ETF",
              asx_code: "FLOT",
              quantity: 3829,
              current_price: 24.97,
              current_value: 95610.13,
              current_percentage: 12.72,
              target_percentage: 13.5,
              product_id: 6,
              product_name: "Australian Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "70AD47",
              target_value: 101442.58,
              difference_value: -5832.45,
              difference_percentage: -0.78,
              action: "buy",
              action_value: 5832.45,
              action_quantity: 233,
            },
            {
              stock_id: 6,
              stock_name: "iShares Core Composite Bond ETF",
              asx_code: "IAF",
              quantity: 275,
              current_price: 103.42,
              current_value: 28440.5,
              current_percentage: 3.78,
              target_percentage: 4,
              product_id: 6,
              product_name: "Australian Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "70AD47",
              target_value: 30057.06,
              difference_value: -1616.56,
              difference_percentage: -0.22,
              action: "none",
              action_value: 0,
              action_quantity: 0,
            },
            {
              stock_id: 21,
              stock_name: "VanEck Vectors Australian Corporate Bond Plus ETF",
              asx_code: "PLUS",
              quantity: 3957,
              current_price: 17.1,
              current_value: 67664.7,
              current_percentage: 9,
              target_percentage: 7,
              product_id: 6,
              product_name: "Australian Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "70AD47",
              target_value: 52599.86,
              difference_value: 15064.84,
              difference_percentage: 2,
              action: "sell",
              action_value: 15064.84,
              action_quantity: 880,
            },
          ],
          current_value: 241105.99,
          target_value: 236699.36,
          difference_value: 4406.63,
          current_percentage: 32.09,
          target_percentage: 31.5,
          difference_percentage: 0.59,
          action: "sell",
          action_value: 4406.63,
        },
        {
          name: "Australian Cash",
          color_code: "9E480E",
          id: 9,
          stocks: [
            {
              stock_id: 1,
              stock_name: "BetaShares Australian High Interest Cash ETF",
              asx_code: "AAA",
              quantity: 2818,
              current_price: 50.21,
              current_value: 141491.78,
              current_percentage: 18.83,
              target_percentage: 20,
              product_id: 9,
              product_name: "Australian Cash",
              category_id: 2,
              category_name: "Defensive",
              color_code: "9E480E",
              target_value: 150285.31,
              difference_value: -8793.53,
              difference_percentage: -1.17,
              action: "buy",
              action_value: 8793.53,
              action_quantity: 175,
            },
            {
              stock_id: 93,
              stock_name: "Platform CASH",
              asx_code: "CASH",
              quantity: 210500,
              current_price: 1,
              current_value: 210500,
              current_percentage: 28.01,
              target_percentage: 3,
              product_id: 9,
              product_name: "Australian Cash",
              category_id: 2,
              category_name: "Defensive",
              color_code: "9E480E",
              target_value: 22542.8,
              difference_value: 187957.2,
              difference_percentage: 25.01,
              action: "sell",
              action_value: 187957.2,
              action_quantity: 0,
            },
          ],
          current_value: 351991.78,
          target_value: 172828.11,
          difference_value: 179163.67,
          current_percentage: 46.84,
          target_percentage: 23,
          difference_percentage: 23.84,
          action: "sell",
          action_value: 179163.67,
        },
        {
          name: "Global Bonds",
          color_code: "264478",
          id: 7,
          stocks: [
            {
              stock_id: 118,
              stock_name: "iShares Core Global Corporate Bond (AUD Hedged) ETF",
              asx_code: "IHCB",
              quantity: 542,
              current_price: 110.71,
              current_value: 60004.82,
              current_percentage: 7.99,
              target_percentage: 8.5,
              product_id: 7,
              product_name: "Global Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "264478",
              target_value: 63871.26,
              difference_value: -3866.44,
              difference_percentage: -0.51,
              action: "buy",
              action_value: 3866.44,
              action_quantity: 34,
            },
            {
              stock_id: 119,
              stock_name:
                "iShares J.P. Morgan USD Emerging Markets Bond (AUD Hedged) ETF",
              asx_code: "IHEB",
              quantity: 951,
              current_price: 74.24,
              current_value: 70602.24,
              current_percentage: 9.4,
              target_percentage: 10,
              product_id: 7,
              product_name: "Global Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "264478",
              target_value: 75142.65,
              difference_value: -4540.41,
              difference_percentage: -0.6,
              action: "buy",
              action_value: 4540.41,
              action_quantity: 61,
            },
            {
              stock_id: 27,
              stock_name:
                "Vanguard International Credit Securities Index (Hedged) ETF",
              asx_code: "VCF",
              quantity: 1540,
              current_price: 38.61,
              current_value: 59459.4,
              current_percentage: 7.91,
              target_percentage: 7,
              product_id: 7,
              product_name: "Global Bonds",
              category_id: 2,
              category_name: "Defensive",
              color_code: "264478",
              target_value: 52599.86,
              difference_value: 6859.54,
              difference_percentage: 0.91,
              action: "sell",
              action_value: 6859.54,
              action_quantity: 177,
            },
          ],
          current_value: 190066.46,
          target_value: 191613.77,
          difference_value: -1547.31,
          current_percentage: 25.29,
          target_percentage: 25.5,
          difference_percentage: -0.21,
          action: "none",
          action_value: 0,
        },
      ],
      current_value: 783164.23,
      target_value: 601141.24,
      difference_value: 182022.99,
      current_percentage: 104.22,
      target_percentage: 80,
      difference_percentage: 24.22,
      action: "sell",
      action_value: 182022.99,
    },
  ]);
  const formatDate = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getPopData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        `/v1/investment-request/stock-purchases/`
      );
      if (response.status == 200) {
        setPopupData(response.data);
        setPopupDataTable(response.data.stocks);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const getPartialData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        `/v1/investment-request/stock-purchase/details/`
      );
      if (response.status == 200) {
        setPopupData(response.data);
        setPopupDataTable(response.data.stocks);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
          setPopupDataTable([]);
          setPopupData(null);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setPopupDataTable([]);
      setPopupData(null);
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const UpdateStatusCall = async (option) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    const apiUrl = `${BASE_URL}/v1/investment-request/stock-purchase/status/`;
    const bodyData = {
      status: option,
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(apiUrl, {
      method: "PUT",
      headers,
      body: JSON.stringify(bodyData),
    });

    return response.json();
  };

  const handleStatusChange = useCallback(
    debounce(async (e, option) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        onClose();

        // const response = await UpdateStatusCall(option);
        // if (response.status == 200) {
        //   setChangeStatus(currentInvestmentId + option);
        //   onClose();
        // } else {
        //   toastMessage = { message: response.message, type: "error" };
        // }
      } catch (err) {
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [] // Dependencies
  );
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {!isLoading && (
        <div className="mx-4 md:mx-0 bg-white w-full max-w-4xl p-4 max-h-[90vh]  overflow-y-auto rounded-lg shadow-lg relative">
          <div className="flex justify-between items-center pb-4 ">
            <h2 className="text-xl font-semibold text-center w-full">
              Request Details
            </h2>
            <button
              onClick={onClose}
              className="absolute right-6 text-gray-500 hover:text-black text-lg"
            >
              <img
                src="/add.svg"
                alt="Close"
                className="w-8 h-8 md:w-10 md:h-10"
              />
            </button>
          </div>
          <div className="bg-white ">
            <div className="flex justify-center items-center border-b mb-4">
              <h3 className="text-md font-semibold mb-2 ">Uploaded Holdings</h3>
            </div>
            {strategyData && strategyData.length > 0 && (
              <div className="space-y-6 mt-4">
                {strategyData.map((category, categoryIdx) => (
                  <div
                    key={categoryIdx}
                    className="rounded-xl shadow-lg overflow-hidden border border-gray-200"
                  >
                    <div
                      className={`text-md font-bold px-4 py-3 ${
                        category.name.toUpperCase() === "GROWTH"
                          ? "bg-gradient-to-r from-blue-300 to-blue-500 text-white"
                          : "bg-gradient-to-r from-green-300 to-green-500 text-white"
                      }`}
                    >
                      {category.name.toUpperCase()}
                    </div>

                    <div className="divide-y divide-gray-200">
                      {category.products.map((product, productIdx) => (
                        <div key={productIdx} className="bg-white">
                          <div className="px-4 py-2 font-semibold text-[#005A9C] bg-gray-100 border-b border-gray-300 text-sm sm:text-base">
                            {String(productIdx + 1).padStart(2, "0")}.{" "}
                            {product.name}
                          </div>

                          {/* Table Wrapper for Horizontal Scroll */}
                          <div className="overflow-x-auto">
                            <table className="min-w-[768px] w-full text-sm text-left">
                              <thead>
                                <tr className="bg-gray-200 text-gray-700">
                                  <th className="px-4 py-3">Stock Name</th>
                                  <th className="px-4 py-3">ASX Code</th>
                                  <th className="px-4 py-3">Quantity</th>
                                  <th className="px-4 py-3">Purchased Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {product.stocks.map((stock, stockIdx) => (
                                  <tr
                                    key={stockIdx}
                                    className="even:bg-gray-50 hover:bg-blue-50 transition"
                                  >
                                    <td className="px-4 py-2 w-[600px] min-w-0 whitespace-normal break-words text-gray-800">
                                      {stock.stock_name}
                                    </td>
                                    <td className="px-4 py-2 text-gray-600">
                                      {stock.asx_code}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {stock.action_quantity
                                        ? stock.action_quantity.toLocaleString()
                                        : "00"}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      02/12/2024
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          {!isView && (
            <div className="flex flex-wrap gap-4 mt-6 font-semibold">
              {/* Approve Button */}
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  handleStatusChange(e, "approved_for_purchase");
                }}
                className="flex items-center justify-center gap-2 px-6 py-3 rounded-xl border-2 border-emerald-500 text-emerald-600 bg-emerald-50 hover:bg-emerald-500 hover:text-white transition duration-200 shadow-sm"
              >
                <span className="uppercase text-sm">Approve</span>
              </button>

              {/* Reject Button */}
              <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  handleStatusChange(e, "rejected");
                }}
                className={`flex items-center justify-center gap-2 px-6 py-3 rounded-xl border-2 transition duration-200 shadow-sm text-sm ${
                  popupData.status === "rejected"
                    ? "bg-rose-500 text-white border-rose-500 hover:bg-rose-600"
                    : "bg-rose-50 text-rose-600 border-rose-500 hover:bg-rose-500 hover:text-white"
                }`}
              >
                <span className="uppercase">Reject</span>
              </button>
            </div>
          )}
        </div>
      )}
      {isLoading && (
        <div className="bg-white w-full max-w-4xl p-6 max-h-[90vh] overflow-y-auto rounded-lg shadow-lg relative animate-pulse">
          {/* Shimmer Header */}
          <div className="flex justify-between items-center pb-4 mb-4">
            <div className="w-1/3 h-6 bg-gray-300 rounded"></div>
            <div className="w-10 h-10 bg-gray-300 rounded-full"></div>
          </div>

          {/* Shimmer Content */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 border rounded p-4">
            {/* Shimmer Client Info */}
            <div className="space-y-3">
              <div className="h-5 bg-gray-300 w-1/2 rounded"></div>
              {[...Array(4)].map((_, i) => (
                <div key={i} className="h-4 bg-gray-300 w-3/4 rounded"></div>
              ))}
            </div>

            {/* Shimmer Portfolio Details */}
            <div className="space-y-3">
              <div className="h-5 bg-gray-300 w-1/2 rounded"></div>
              {[...Array(4)].map((_, i) => (
                <div key={i} className="h-4 bg-gray-300 w-3/4 rounded"></div>
              ))}
            </div>
          </div>

          {/* Shimmer Table */}
          <div className="overflow-x-auto max-h-[70vh] font-medium overflow-y-auto mb-6">
            <table className="table-auto w-full border rounded border-gray-300">
              <thead>
                <tr className="text-left text-xs">
                  {[...Array(6)].map((_, i) => (
                    <th key={i} className="px-4 py-2 border bg-gray-200"></th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[...Array(5)].map((_, rowIndex) => (
                  <tr key={rowIndex}>
                    {[...Array(6)].map((_, colIndex) => (
                      <td key={colIndex} className="px-4 py-2 border">
                        <div className="h-4 bg-gray-300 rounded"></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewAccessRequestPopup;
